module.exports = __webpack_public_path__ + "static/media/pay-by-omise-paynow.521de447.png";